import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    document.documentElement.style.scrollBehavior = "smooth"
  }

  disconnect() {
    document.documentElement.style.scrollBehavior = ""
  }
}
